import { Box, MenuItem, Text } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorTokens } from '../../../shared/components/variables';

export const StyledMenuItem = styled(MenuItem)`
  && {
    &:hover {
      background-color: ${colorTokens.primary.hover};
    }
  }
`;

export const PlaceholderText = styled(Text)`
  && {
    color: ${colorTokens.secondary.disabled};
    font-size: 13px;
  }
`;

export const Error = styled(Text)`
  margin: 5px 16px 0;
  font-size: 13px;
  font-weight: 300;
  color: ${colorTokens.error.main};
`;

export const ChipSelectContainer = styled(Box)`
  width: 100%;
`;
